/**
 * This library has external dependencies that need to be provided by the host app in the module.
 * Provided type for PARTNER_ID_TOKEN, MARKET_ID_TOKEN, and BUSINESS_ID_TOKEN is `Observable<string>`.
 *
 * Example:
 * @NgModule({
 *   declarations: [MyHostComponent],
 *   providers: [
 *     {provide: PARTNER_ID_TOKEN, useExisting: MY_EXISTING_PROVIDED_PARTNER_ID},
 *     {provide: MARKET_ID_TOKEN, useValue: of('my-market-id')},
 *     {provide: BUSINESS_ID_TOKEN, useFactory: myFactoryFn(myDep: MyServiceDep), deps: [MyServiceDep]},
 *   ],
 * })
 * export class MyHostModule {}
 *
 *
 * @Component({
 *   selector: 'my-host-component',
 *   template: `
 *     <sales-order-confirmation></sales-order-confirmation>
 *   `,
 * })
 * export class MyHostComponent {}
 */
export const PARTNER_ID_TOKEN = 'partnerId$';
export const MARKET_ID_TOKEN = 'marketId$';

/*
 * BUSINESS_ID_TOKEN is an OPTIONAL value provided to the SalesOrderLineitemSelector. If provided it will lookup
 * the apps that a business already has activated and mark those rows as already activated in the products table.
 */
export const BUSINESS_ID_TOKEN = 'businessId$';

/**
 * Provided type is `Observable<Market[]>`, where Market is defined as
 * export interface Market {
 *   name: string;
 *   marketId: string;
 * }
 */
export const MARKET_IDS_TOKEN = 'markets$';

/**
 * Provided type is `Observable<Salesperson[]>`, where Salesperson is defined as
 * export interface Salesperson {
 *   name: string;
 *   salespersonId: string;
 * }
 */
export const SALESPEOPLE_TOKEN = 'salespeople$';

/**
 * Provided type is `Observable<Salesteam[]>`, where Salesteam has value
 * export interface Salesteam {
 *   id: string;
 *   teamName: string;
 * }
 */
export const SALES_TEAMS_TOKEN = 'salesTeams$';
